import SidebarNavigation from "features/History/components/SidebarNavigation";
import NewThreadButton from "features/NewThreadButton";
import useIncognitoMode from "features/User/hooks/useIncognitoMode";
import { useSidebar } from "hooks/useSidebar";
import { useAppSelector } from "hooks/useStore";
import { IncognitoModeBanner } from "./IncognitoModeBanner";
function SignedInContent() {
  const { toggleSidebar } = useSidebar();
  const isMobile = useAppSelector((state) => state.setting.isMobile);

  const handleOnNavigate = () => {
    if (isMobile) {
      toggleSidebar();
    }
  };

  const { isIncognitoModeActive } = useIncognitoMode();

  return (
    <div className="h-full flex flex-col gap-6 overflow-hidden">
      <div className="flex flex-col gap-1">
        <NewThreadButton asSidebarNavItem />
        <SidebarNavigation onNavigate={handleOnNavigate} />
      </div>
      {isIncognitoModeActive && <IncognitoModeBanner />}
    </div>
  );
}

export default SignedInContent;
